// ⚠️ IMPORT ORDER IS CRITICAL:
// 1. Amplify.configure() MUST be called before ReactDOM.createRoot
// 2. globals.css must be imported before any component
import { configureAmplify } from './lib/amplify';
import './styles/globals.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';

// Configure Amplify synchronously before React tree mounts
configureAmplify();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found in index.html');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
